module.exports = __webpack_public_path__ + "0d81e0c53df761a15d10e1558f596c9f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-directory-label/sp-directory-label.html
// module id = 995
// module chunks = 0